export enum IncidentTypes {
	// REPORT_INCIDENT = 'REPORT_INCIDENT',
	// REPORT_WRONG_INFORMATION = 'REPORT_WRONG_INFORMATION',
	// REPORT_GLOBAL_ISSUE = 'REPORT_GLOBAL_ISSUE',
	REPORT_INCIDENT = '2',
	REPORT_WRONG_INFORMATION = '1',
}
